import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class SideDoors extends Component {
  render() {
    return (
      <EntityList apiRoute='api/sidedoors' title='Remorque - Portes de côté' editTitle='Porte de côté' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Nombre de porte', Column: 'NumberDoor'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default SideDoors;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/sideDoors.js
 **/